/**
 * `Ops: OpsApi` (W1-03 core-model-ops; contract core/ops/types.ts, ARCHITECTURE.md §5.2): the facade over op
 * inversion, coalescing, dirty scopes, per-transaction validation, shadow rules and document diffing.
 * Op application itself lives with the container (core/doc/apply.ts).
 */

import { composeOps } from './compose';
import { diffDocs } from './diff';
import { dirtyOf, emptyDirty, mergeDirty } from './dirty';
import { invertOp, invertOps } from './invert';
import { withShadow } from './shadow';
import type { OpsApi } from './types';
import { validateTouched } from './validate';

export const Ops: OpsApi = {
  invert: invertOp,
  invertAll: invertOps,
  compose: composeOps,
  dirtyOf,
  emptyDirty,
  mergeDirty,
  validateTouched,
  withShadow,
  diff: diffDocs,
};
